import { PageHeader } from "@/components/page-header";
import { DocButton } from "@/components/ui/doc-button";
import { usePortfolioCollections } from "@/lib/hooks/use-portfolio-collections";
import { useActiveRiskModels } from "@/lib/hooks/use-risk-models";
import { useT } from "@/lib/i18n/use-t";
import { PortfolioCollectionsLoader } from "./portfolio-collections-loader";
import { PortfolioCollectionsTable } from "./portfolio-collections-table";
import { T } from "./portfolios-wrapper.i18n";

export function PortfoliosWrapper() {
  const t = useT(T);
  const { collections, isLoading } = usePortfolioCollections();
  const { models: riskModels } = useActiveRiskModels();

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={[{ label: t.settings, href: "/settings" }, { label: t.portfolioCollections }]}
        title={t.portfolioCollections}
        description={t.pageDescription}
        actions={
          <DocButton docSlug="portfolios" variant="outline" size="sm" className="gap-2">
            {t.documentation}
          </DocButton>
        }
      />

      {isLoading && collections.length === 0 ? (
        <PortfolioCollectionsLoader />
      ) : (
        <PortfolioCollectionsTable collections={collections} riskModels={riskModels} />
      )}
    </div>
  );
}
